import { ClientConfig } from "agora-rtc-sdk-ng";

/**
 * Config for Agora RTC engine
 */
export const config: ClientConfig = { 
    mode: "rtc", 
    codec: "vp8",
};
